module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("THE CANOPY")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "page33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#aa5",
      "id": "bb5"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRI")]), _vm._v("L 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#aa5"
    }
  }, [_vm._v("11:47 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": ".",
      "id": "p0033-d6e26",
      "src": "images/9780849943454_INT_0033_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0033-03-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("D")]), _vm._v("ripping like a wet sponge, Michael backed through the double doors of the surgery, then moved toward the sink to peel off his bloody gloves. After doffing the gloves and tugging the surgical mask from his face, he picked up a bottle of lukewarm water and gulped it down, then reached for a towel to mop his neck and forehead. His patient would probably not survive more than a few hours, but he had done his best.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-04-4"
    }
  }, [_vm._v("Looping the damp towel around his neck, he carried another bottle of water through an adjoining corridor that led to a courtyard. Though the sun beat mercilessly upon the garishly painted concrete slab that passed for decorative pavement, the area was at least fifteen degrees cooler than his oven of an operating room. His operating theater, if one could call it that, was a windowless room with an operating table at the center, a single light overhead, and not even a fan to move the stultifying air. Michael had perspired profusely during the entire procedure, soaking his scrub suit, surgical gown, and cap.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-05-6"
    }
  }, [_vm._v("He had scrubbed up under conditions that would horrify his colleagues in Britain (a bucket of water served as a sink because no water flowed into the hospital after 7 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(") and operated in a sauna that would compel less demanding surgeons to resign in protest. He had been assisted by one unsuperstitious orderly, two surgical nurses, and one anesthesiologist. He had cut with a scalpel that had obviously seen sharper days, and he was certain the cloth covering the operating table had not been changed since the previous procedure that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-06-8"
    }
  }, [_vm._v("Most surprising had been the conclusion he’d reached after opening the wound—his patient’s abdomen had been pierced by some type of spear, most likely a sharpened stone, for Michael had pulled flakes of chipped rock from the peritoneal cavity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0033-07-10"
    }
  }, [_vm._v("The presence of rock fragments made him lift a brow. There was no"), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v(" rock in this part of the Amazon. The stones used by the Indians for cultivating crops, sharpening machetes, and grinding food were purchased from a “stone man” who gathered his stones near his home in the foothills of the Andes, then traveled downriver selling his wares. So this man had either been injured by a weapon carved of relatively rare rock . . . or he had come from some part of the jungle far away from Iquitos.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-02-1"
    }
  }, [_vm._v("He’d wager a decent shepherd’s pie that none of his mates at St. George’s Hospital in London would treat a stone-spear wound in the entire length of the coming year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-02-2"
    }
  }, [_vm._v("Michael pulled off his cap, then shook his head and ran his fingers through his wet hair. A medical practice at the jungle’s edge kept life interesting . . . and kept his thoughts occupied. Which was the entire point of his being in this godforsaken place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-03-4"
    }
  }, [_vm._v("He flinched when Fortuna interrupted his reverie by slamming the exit door against the concrete wall. "), _c('i', [_vm._v("“El doctor!")]), _vm._v(" The patient is awake.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-03-5"
    }
  }, [_vm._v("Michael glanced at his watch. The man had recovered from the anesthetic rather quickly, but the anesthesiologist might not have administered the proper dosage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-04-7"
    }
  }, [_vm._v("He stood and walked toward his nurse. “Is he in pain?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-05-9"
    }
  }, [_c('i', [_vm._v("“No se,")]), _vm._v(" Doctor. He is talking, but I cannot understand him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-06-11"
    }
  }, [_vm._v("Michael frowned. “He does not speak Spanish?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-07-13"
    }
  }, [_vm._v("“I believe he is speaking an Indian dialect. I do not recognize it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-07-14"
    }
  }, [_vm._v("Michael exhaled as he led the way to the postoperative ward. The man could be babbling nonsense in his pain, but if he could communicate at all, they needed to ask for his name and the name of his nearest relative. As the anesthesia wore off, perhaps one of the hospital staff could find a way to communicate with the unlucky fellow.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-08-16"
    }
  }, [_vm._v("The patient lay on a gurney in the postoperative ward, his hands loosely bound by restraints to prevent him from disturbing the dressing. Michael leaned over the man and checked his breathing, then noted the blood pressure on the chart. An IV next to the bed dripped cefoxitin— the strongest antibiotic available in this place—into his veins.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0034-09-18"
    }
  }, [_vm._v("Michael leaned over his patient when the man’s eyelids fluttered. "), _c('i', [_vm._v("“ ¿Senor? ¿Está usted en dolor?”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("The man’s lids opened to reveal hazel eyes, a color Michael had never seen among the native peoples. For an instant the patient’s body tensed in an atavistic flee-or-fight reflex, then he closed his eyes, relaxed against the restraints, and began to mumble in a low monotone.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-02-2"
    }
  }, [_vm._v("Michael listened a moment, then turned to Fortuna. “Is he speaking Yagua?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-03-4"
    }
  }, [_vm._v("She shook her head. “I do not think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-04-6"
    }
  }, [_vm._v("“Is anyone around here fluent in the native dialects? If this man has relatives, we’ll need to find them as soon as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-05-8"
    }
  }, [_c('i', [_vm._v("“Un momento, el doctor.")]), _vm._v(" I will ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-06-10"
    }
  }, [_vm._v("Fortuna spun on the sole of her sneakers, then disappeared behind the curtained divider. While she searched, Michael checked the man’s vital signs and his urine output, then leaned over the bed railings to listen to the native’s mumbling. Three years in Peru had improved Michael’s Spanish to the point where he could usually follow the thread of a conversation, but these words bore no resemblance to the Spanish spoken in every Peruvian city and most of the Indian villages. This could be Yagua, Witotoan, or one of three hundred other Indian tongues, but those languages had nearly died out except in the native villages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-07-12"
    }
  }, [_vm._v("The man was definitely speaking "), _c('i', [_vm._v("something,")]), _vm._v(" though, and it didn’t sound like gibberish. He seemed to be chanting, perhaps even singing . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-08-14"
    }
  }, [_vm._v("Fortuna came around the curtain, followed by a dark-haired woman Michael had seen in the administrator’s office. “This is Esma,” Fortuna explained offhandedly. “She speaks Yagua and English.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-09-16"
    }
  }, [_vm._v("The tip of Esma’s nose went pink as she looked at the tattooed man in the bed. “I "), _c('i', [_vm._v("did")]), _vm._v(" speak Yagua,” she said, meeting Michael’s gaze. “When I lived with my parents. But that was a long time ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-10-18"
    }
  }, [_vm._v("“Please.” Michael gripped the side rails of the bed. “He came from out of the jungle, and his prognosis is not good. See if you can discover anything that will lead us to his family.” Straightening, he turned to Fortuna and lowered his voice. “We’ll need to watch him carefully for the next twelve hours.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0035-11-20"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Esma moved toward the head of the bed, then leaned on the railing")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v(" and whispered a greeting in a tongue Michael had never heard. At the sound of her voice the patient’s eyes flew open, bewilderment creasing his lined face.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-02-2"
    }
  }, [_vm._v("Glancing up at Michael, Esma asked a question—presumably about his family. The patient stared at Esma a moment, shifted his eyes to Michael and Fortuna, then began to speak in abrupt, hoarse tones, his voice cracking with every word. When he paused to cough, frothy, bloodtinged sputum tinged his lips—a sign of adult respiratory distress syndrome. A patient who developed ARDS would not likely last the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-P-1"
    }
  }, [_vm._v("“Has he a name?” Michael raised his voice to be heard above the man’s coughing. “A wife? Someone we can call?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-03-4"
    }
  }, [_vm._v("Esma cut Michael off with an uplifted hand, then repeated the question. Confusion filled the patient’s eyes, then he released a stream of flowing words that did not slow even when Esma turned to Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-P-2"
    }
  }, [_vm._v("“The language is not Yagua, but it may be related. I do not know all of the words, but I think I may be able to understand some of what he is saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-04-6"
    }
  }, [_vm._v("Michael crossed his arms. “Has he family nearby? That is the crucial thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-05-8"
    }
  }, [_vm._v("The translator showed her teeth in a humorless smile. “Patience, Doctor. He seems intent on telling me a story. Every time you interrupt, he begins again.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-06-10"
    }
  }, [_vm._v("“That’s lovely,” Michael answered, his voice coagulating with sarcasm, “but I need to know about his next of kin "), _c('i', [_vm._v("now")]), _vm._v(". We may have to send someone downriver.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-07-12"
    }
  }, [_vm._v("Esma gave him the pointed look he always received when he inadvertently committed a cultural blunder. “He did not answer me, Doctor, and I think I know the reason why. You will not need to send for anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-08-14"
    }
  }, [_vm._v("Michael closed his fist around the bed railing. “And how, exactly, would you know this, seeing that he has not spoken a word that makes any sense?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0036-09-16"
    }
  }, [_vm._v("Lifting her chin, Esma spoke with quiet firmness. “He will not give me names, Doctor, because the jungle tribes consider it evil to speak the names of their loved ones . . . particularly those who are dead.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb563606","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter8.vue
// module id = 87
// module chunks = 0